import { useNavigate, useLocation } from 'react-router-dom'
export function useBackNavigation(defaultPath: string = '/work') {
  const navigate = useNavigate()
  const location = useLocation()
  const goBack = () => {
    // If we have a "from" state, go back to that page
    if (location.state?.from) {
      navigate(location.state.from)
    } else {
      // Navigate to default path with hash to scroll to collaborate section
      const path = defaultPath === '/work' ? '/work#collaborate' : defaultPath
      navigate(path)
    }
  }
  return goBack
}
